/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { Select, MenuItem, Modal, Stack, Grid, Button, Box, Tooltip, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { defaultModalOptions, defaultUnitSetDict } from '../../shared/constantVariable';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import Notification from '../../shared/notification-modal';
import { getBorderColor } from '../../shared/utils';
import { closeIconBlack } from '../../shared/assets/images';
import { convertUnitValues_flow, convertUnitValues_power, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import './work-exchanger.scss';
import { output_data } from './output_data';

let unit_set_dict = defaultUnitSetDict();
const headerData = ['Parameter', 'Unit', 'Values'];
let output_dataCopy = JSON.parse(JSON.stringify(output_data));
let currentVal = 0;
const resRange = { min: 0, max: 0 };
let currentFlag = true;

const WorkExchangerForm = (props) => {
  const { visibleWorkExchanger, workExchanger, handleCloseWorkExchanger, disabledStripperAndExplorerTab, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [activeform, setActiveForm] = useState('work_exc');
  const stackModels = ['Auto', 'Manual'];
  const [workExcModel, setWorkExcModel] = useState('Auto');
  const [pressExcModel, setPressExcModel] = useState('Auto');
  const [workExchangerVal, setWorkExchangerVal] = useState({});
  const [pressureExchangerVal, setPressureExchangerVal] = useState({});
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [hpPumpId, setHpPumpId] = useState('');

  let work_exchanger = [...output_dataCopy.work_exchanger];
  let pressure_exchanger = [...output_dataCopy.pressure_exchanger];

  const getUnitsData = () => {
    return {
      'Volume Flow': 'gpm',
      'Pressure': 'atm',
      'Temperature': '°C',
      'Liquid Volume': 'gal',
      'Flux': 'gfd',
      'Power': 'kW'
    };
  };

  const getCurrentValue = (e) => {
    if (currentFlag) {
      currentFlag = false;
      currentVal = (e.target.value) ? Number(e.target.value) : 0;
    }
  };
  const getWorkExchangerName = () => {
    let workexchanger = '';
    const local = localStorage.getItem(workExchanger.id);
    if (local) {
      workexchanger = ` - ${local}`;
    } else {
      workexchanger = ` - Pump ${Number(get(workExchanger, 'id', '').split('_')[1]) + 1}`;
    }
    return workexchanger;
  };
  const decimalValue = (val) => {
    return val.toFixed(3);
  };

  const handleCloseWork_Exchanger = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseWorkExchanger();
  };

  const handleCloseWorkExchangerModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleCloseWork_Exchanger(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseWorkExchanger();
    };
  };
  /* function call when click on OK button */
  const setDataOnStorage = () => {
    const previous_pressure_unit = 'atm';
    const workExcObj = { 'Unit Type': 'ERD', 'erd_type': 'wex', 'is_auto': true, 'finalData': {} };
    const pressExcObj = { 'finalData': {} };
    let hppumpdata = localStorage.getItem('hp-pump-dict');
    if (hppumpdata) {
      hppumpdata = JSON.parse(hppumpdata);
    }
    workExcObj.finalData['work_exc-model'] = workExcModel;
    work_exchanger.forEach((ele) => {
      workExcObj.finalData[ele.key] = ele.val;
      if (ele.key === 'lp_dicharge_pres') {
        workExcObj.finalData[ele.key] = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
      }
    });
    pressExcObj.finalData['press_exc-model'] = pressExcModel;
    pressure_exchanger.forEach((ele) => {
      pressExcObj.finalData[ele.key] = ele.val;
      if (ele.key === 'lp_dicharge_pres') {
        pressExcObj.finalData[ele.key] = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
      }
    });
    /* work_exchanger start */
    if (activeform === 'work_exc') {
      work_exchanger.forEach((ele) => {
        if (['lp_dicharge_pres', 'leakage', 'cost_power'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = Number(ele.val);
          if (ele.key === 'lp_dicharge_pres') {
            workExcObj[ele.key] = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
          }
        } else if (workExcModel !== 'Auto' && ['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = Number(ele.val);
        } else if (hppumpdata && Object.keys(hppumpdata).length) {
          if (ele.key === 'cir_p_eff') {
            workExcObj[ele.key] = hppumpdata.hppump[hpPumpId.id] ? Number(hppumpdata.hppump[hpPumpId.id].pump_efficiency) : 0;
          } else if (ele.key === 'cir_m_eff') {
            workExcObj[ele.key] = hppumpdata.hppump[hpPumpId.id] ? Number(hppumpdata.hppump[hpPumpId.id].motor_efficiency) : 0;
          } else if (ele.key === 'cir_vfd_eff') {
            workExcObj[ele.key] = hppumpdata.hppump[hpPumpId.id] ? Number(hppumpdata.hppump[hpPumpId.id].vfd_efficiency) : 0;
          }
        } else if (['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = 0;
        }
      });
      if (workExcModel !== 'Auto') {
        workExcObj.is_auto = false;
      }
    } else if (activeform === 'pressure_exc') {
      workExcObj.erd_type = 'pex';
      pressure_exchanger.forEach((ele) => {
        if (['lp_dicharge_pres', 'leakage', 'cost_power'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = Number(ele.val);
          if (ele.key === 'lp_dicharge_pres') {
            workExcObj[ele.key] = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
          }
        } else if (pressExcModel !== 'Auto' && ['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = Number(ele.val);
        } else if (hppumpdata && Object.keys(hppumpdata).length) {
          if (ele.key === 'cir_p_eff') {
            workExcObj[ele.key] = Number(hppumpdata.hppump[hpPumpId.id].pump_efficiency);
          } else if (ele.key === 'cir_m_eff') {
            workExcObj[ele.key] = Number(hppumpdata.hppump[hpPumpId.id].motor_efficiency);
          } else if (ele.key === 'cir_vfd_eff') {
            workExcObj[ele.key] = Number(hppumpdata.hppump[hpPumpId.id].vfd_efficiency);
          }
        } else if (['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          workExcObj[ele.key] = 0;
        }
      });
      if (pressExcModel !== 'Auto') {
        workExcObj.is_auto = false;
      }
    }
    saveFormDataInLocalStorage({
      record: workExcObj,
      type: 'work_exc',
      id: workExchanger.id,
      item: 'work_exc-dict'
    });
    saveFormDataInLocalStorage({
      record: pressExcObj,
      type: 'press_exc',
      id: workExchanger.id,
      item: 'press_exc-dict'
    });
    /* pressure_exchanger End */
    localStorage.setItem('current-unit-work', JSON.stringify(unit_set_dict));
    handleCloseWorkExchanger();
    getBorderColor(workExchanger.id);
    setokbuttonFormAutoSave(true);
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
  };
  const getDefaultWorkExcData = (e, str) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (str === 'work_exc' && (e.target.value === 'Auto' || e.target.value === 'Manual')) {
      setWorkExcModel(e.target.value);
      for (let i = 0; i < work_exchanger.length; i += 1) {
        work_exchanger[i].class = '';
        if (work_exchanger[i].key === 'lp_dicharge_pres') {
          work_exchanger[i].class = 'highilted';
        } else if (work_exchanger[i].key === 'leakage') {
          work_exchanger[i].class = 'highilted';
        } else if (work_exchanger[i].key === 'cost_power') {
          work_exchanger[i].class = 'highilted';
        }
        if (e.target.value === 'Manual') {
          if (work_exchanger[i].key === 'cir_p_eff') {
            work_exchanger[i].class = 'highilted';
          } else if (work_exchanger[i].key === 'cir_m_eff') {
            work_exchanger[i].class = 'highilted';
          } else if (work_exchanger[i].key === 'cir_vfd_eff') {
            work_exchanger[i].class = 'highilted';
          }
        }
      }
    } else if (str === 'pressure_exc' && (e.target.value === 'Auto' || e.target.value === 'Manual')) {
      setPressExcModel(e.target.value);
      for (let i = 0; i < pressure_exchanger.length; i += 1) {
        pressure_exchanger[i].class = '';
        if (pressure_exchanger[i].key === 'lp_dicharge_pres') {
          pressure_exchanger[i].class = 'highilted';
        } else if (pressure_exchanger[i].key === 'leakage') {
          pressure_exchanger[i].class = 'highilted';
        } else if (pressure_exchanger[i].key === 'cost_power') {
          pressure_exchanger[i].class = 'highilted';
        }
        if (e.target.value === 'Manual') {
          if (pressure_exchanger[i].key === 'cir_p_eff') {
            pressure_exchanger[i].class = 'highilted';
          } else if (pressure_exchanger[i].key === 'cir_m_eff') {
            pressure_exchanger[i].class = 'highilted';
          } else if (pressure_exchanger[i].key === 'cir_vfd_eff') {
            pressure_exchanger[i].class = 'highilted';
          }
        }
      }
    }
  };
  const changeUnit = () => {
    let previousUnit = localStorage.getItem('current-unit-work');
    // previousUnit is present the pase the previousUnit otherwise get the default units.
    previousUnit = previousUnit ? JSON.parse(previousUnit) : getUnitsData();
    const previous_pressure_unit = 'atm';
    /* work exchanger Start */
    let exchangerModel = '';
    let wex_dict = localStorage.getItem('work_exc-dict');
    if (wex_dict) {
      const { id } = workExchanger;
      wex_dict = get(JSON.parse(localStorage.getItem('work_exc-dict')), 'work_exc', {});
      if (wex_dict[id]) {
        exchangerModel = wex_dict[id].erd_type;
      }
      wex_dict = (wex_dict[id] && wex_dict[id].finalData) ? wex_dict[id].finalData : '';
      setWorkExcModel(wex_dict['work_exc-model'] ? wex_dict['work_exc-model'] : workExcModel);
      getDefaultWorkExcData({ target: { value: wex_dict['work_exc-model'] } }, 'work_exc');
    }
    work_exchanger.forEach((ele) => {
      if (ele.key === 'ro_permeate_flow') {
        ele.unit = unit_set_dict['Volume Flow'];
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_flow(parseFloat(ele.val), previousUnit['Volume Flow'], unit_set_dict['Volume Flow'])));
        }
      } else if (['lp_dicharge_pres', 'ro_feed_pressure', 'membrane_diff_pressure', 'pressure_HP', 'pressure_LP'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Pressure;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_pressure(parseFloat(ele.val), previousUnit.Pressure, unit_set_dict.Pressure)));
        }
      } else if (['power_savings', 'HP_power_con', 'power_consumed', 'power_consumption'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Power;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_power(parseFloat(ele.val), previousUnit.Power, unit_set_dict.Power)));
        }
      }
      if (wex_dict) {
        if (['lp_dicharge_pres', 'leakage', 'cost_power', 'cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          if (wex_dict['work_exc-model'] === 'Auto' && ['lp_dicharge_pres', 'leakage', 'cost_power'].indexOf(ele.key) >= 0) {
            let val = Number(wex_dict[ele.key]);
            if (ele.key === 'lp_dicharge_pres') {
              val = Number(convertUnitValues_pressure(val, previous_pressure_unit, unit_set_dict.Pressure));
            }
            ele.val = decimalValue(val);
          } else if (wex_dict['work_exc-model'] === 'Manual') {
            ele.val = decimalValue(Number(wex_dict[ele.key]));
          }
        }
      }
    });
    /* work exchanger End */
    /* Presser exchanger Start */
    let pex_dict = localStorage.getItem('press_exc-dict');
    if (pex_dict) {
      pex_dict = get(JSON.parse(localStorage.getItem('press_exc-dict')), 'press_exc', {});
      const { id } = workExchanger;
      pex_dict = (pex_dict[id] && pex_dict[id].finalData) ? pex_dict[id].finalData : '';
      setPressExcModel(pex_dict['press_exc-model'] ? pex_dict['press_exc-model'] : pressExcModel);
      getDefaultWorkExcData({ target: { value: pex_dict['press_exc-model'] } }, 'pressure_exc');
    }
    pressure_exchanger.forEach((ele) => {
      if (['ro_permeate_flow', 'lubrication_per_array', 'unit_flow'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict['Volume Flow'];
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_flow(parseFloat(ele.val), previousUnit['Volume Flow'], unit_set_dict['Volume Flow'])));
        }
      } else if (['lp_dicharge_pres', 'ro_feed_pressure', 'membrane_diff_pressure', 'pressure_HP', 'pressure_LP'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Pressure;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_pressure(parseFloat(ele.val), previousUnit.Pressure, unit_set_dict.Pressure)));
        }
      } else if (['power_savings', 'HP_power_con', 'power_consumed', 'power_consumption'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Power;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_power(parseFloat(ele.val), previousUnit.Power, unit_set_dict.Power)));
        }
      }
      if (pex_dict) {
        if (['lp_dicharge_pres', 'leakage', 'cost_power', 'cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(ele.key) >= 0) {
          if (pex_dict['press_exc-model'] === 'Auto' && ['lp_dicharge_pres', 'leakage', 'cost_power'].indexOf(ele.key) >= 0) {
            let val = Number(pex_dict[ele.key]);
            if (ele.key === 'lp_dicharge_pres') {
              val = Number(convertUnitValues_pressure(val, previous_pressure_unit, unit_set_dict.Pressure));
            }
            ele.val = decimalValue(val);
          } else if (pex_dict['press_exc-model'] === 'Manual') {
            ele.val = decimalValue(Number(pex_dict[ele.key]));
          }
        }
      }
    });
    if (exchangerModel) {
      const e = { target: { value: '' } };
      let str = '';
      if (exchangerModel === 'wex') {
        setActiveForm('work_exc');
        e.target.value = wex_dict['work_exc-model'];
        str = 'work_exc';
      } else if (exchangerModel === 'pex') {
        setActiveForm('pressure_exc');
        e.target.value = pex_dict['press_exc-model'];
        str = 'pressure_exc';
      }
      getDefaultWorkExcData(e, str);
    }
    /* Presser exchanger End */
    setWorkExchangerVal(work_exchanger);
    setPressureExchangerVal(pressure_exchanger);
  };
  const updateWorkExchangerValue = (data) => {
    setWorkExcModel(data.Manual);
    for (let i = 0; i < work_exchanger.length; i += 1) {
      work_exchanger[i].val = data[work_exchanger[i].outputKey] ? decimalValue(Number(data[work_exchanger[i].outputKey])) : decimalValue(0);
    };
    for (let i = 0; i < pressure_exchanger.length; i += 1) {
      pressure_exchanger[i].val = data[pressure_exchanger[i].outputKey] ? decimalValue(Number(data[pressure_exchanger[i].outputKey])) : decimalValue(0);
      if (pressure_exchanger[i].outputKey === 'Model') {
        pressure_exchanger[i].val = data[pressure_exchanger[i].outputKey] ? data[pressure_exchanger[i].outputKey] : 0;
      }
    };
    changeUnit();
  };
  const showWarningMsg = (message) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message, // `Target Resistivity must be between ${resRange.min} and ${resRange.max}`
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions)
    });
  };
  const changeVal = (str, ind, eve) => {
    if (str === 'work') {
      if (work_exchanger[ind].key === 'lp_dicharge_pres') {
        resRange.min = 0; resRange.max = 68.0457;
        const previous_pressure_unit = 'atm';
        resRange.min = Number(convertUnitValues_pressure(resRange.min, previous_pressure_unit, unit_set_dict.Pressure));
        resRange.max = Number(convertUnitValues_pressure(resRange.max, previous_pressure_unit, unit_set_dict.Pressure));
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`LP Discharge Pressure must be between ${resRange.min} ${unit_set_dict.Pressure} and ${resRange.max} ${unit_set_dict.Pressure}`);
          work_exchanger[ind].val = currentVal;
        } else {
          work_exchanger[ind].val = eve.target.value;
        }
      } else if (work_exchanger[ind].key === 'leakage') {
        resRange.min = 0; resRange.max = 20;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Leakage must be between ${resRange.min} and ${resRange.max}`);
          work_exchanger[ind].val = currentVal;
        } else {
          work_exchanger[ind].val = eve.target.value;
        }
      } else if (work_exchanger[ind].key === 'cost_power') {
        resRange.min = 0; resRange.max = 10;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Cost of Power must be between ${resRange.min} and ${resRange.max}`);
          work_exchanger[ind].val = currentVal;
        } else {
          work_exchanger[ind].val = eve.target.value;
        }
      } else if (['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(work_exchanger[ind].key) >= 0) {
        resRange.min = 0; resRange.max = 95;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Net transfer Efficiencies must be between ${resRange.min} and ${resRange.max}`);
          work_exchanger[ind].val = currentVal;
        } else {
          work_exchanger[ind].val = eve.target.value;
        }
      }
      disabledStripperAndExplorerTab();
      setWorkExchangerVal(work_exchanger);
    } else if (str === 'press') {
      if (pressure_exchanger[ind].key === 'lp_dicharge_pres') {
        pressure_exchanger[ind].val = eve.target.value;
      } else if (pressure_exchanger[ind].key === 'leakage') {
        resRange.min = 0; resRange.max = 20;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Leakage must be between ${resRange.min} and ${resRange.max}`);
          pressure_exchanger[ind].val = currentVal;
        } else {
          pressure_exchanger[ind].val = eve.target.value;
        }
      } else if (pressure_exchanger[ind].key === 'cost_power') {
        resRange.min = 0; resRange.max = 10;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Cost of Power must be between ${resRange.min} and ${resRange.max}`);
          pressure_exchanger[ind].val = currentVal;
        } else {
          pressure_exchanger[ind].val = eve.target.value;
        }
      } else if (['cir_p_eff', 'cir_m_eff', 'cir_vfd_eff'].indexOf(pressure_exchanger[ind].key) >= 0) {
        resRange.min = 0; resRange.max = 95;
        if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
          showWarningMsg(`Net transfer Efficiencies must be between ${resRange.min} and ${resRange.max}`);
          pressure_exchanger[ind].val = currentVal;
        } else {
          pressure_exchanger[ind].val = eve.target.value;
        }
      }
      disabledStripperAndExplorerTab();
      setPressureExchangerVal(pressure_exchanger);
    }
  };
  const blurVal = (str, ind, eve) => {
    if (str === 'work') {
      work_exchanger[ind].val = decimalValue(Number(eve.target.value));
      setWorkExchangerVal(work_exchanger);
    } else if (str === ' press') {
      pressure_exchanger[ind].val = decimalValue(Number(eve.target.value));
      setPressureExchangerVal(pressure_exchanger);
    }
    currentFlag = true;
  };
  useEffect(() => {
    output_dataCopy = JSON.parse(JSON.stringify(output_data));
    work_exchanger = [...output_dataCopy.work_exchanger];
    pressure_exchanger = [...output_dataCopy.pressure_exchanger];
    if (localStorage.getItem('unit_set_dict')) {
      unit_set_dict = JSON.parse(localStorage.getItem('unit_set_dict'));
    }
    // Edit Case
    let storeNodes = localStorage.getItem('storeNodes');
    if (storeNodes) {
      storeNodes = JSON.parse(storeNodes);
      storeNodes = storeNodes.filter((ele) => {
        return ((ele.parentNode === workExchanger.parentNode) && (ele.type === 'customnode_pump_hp'));
      });
      if (storeNodes.length > 0) {
        setHpPumpId(storeNodes[0]);
      } else {
        setHpPumpId({ id: 'hppump_1' });
      }
    }
    if (localStorage.getItem('ro_ouput_data')) {
      let data = JSON.parse(localStorage.getItem('ro_ouput_data'));
      if (data) {
        data = Object.values(JSON.parse(localStorage.getItem('ro_ouput_data'))).filter((ele) => {
          return ele.unit_type === 'ERD';
        });
        if (data.length > 0) {
          data = data[0];
        }
        const erd_data = data;
        if (Object.keys(erd_data).length) {
          setTimeout(() => {
            updateWorkExchangerValue(erd_data.output_user);
          }, 0);
        } else {
          changeUnit();
        }
      }
    } else {
      changeUnit();
    }
  }, []);
  return (
    <Modal hideBackdrop open={visibleWorkExchanger} onClose={handleCloseWorkExchangerModal} className='splitter-modal'>
      <Box>
        <Rnd
          default={{
            width: '70%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((60 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='50%'
          cancel='.no_drag'
          className='work-exchanger-box'>
          <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
          <Grid className='work-exchanger-wrapper'>
            <Grid item xs={12} className='work-exchanger-header-grid'>
              <div className='work-exchanger-grid-title rufusBld no_drag S_heading forground-text-primary'>{`Energy Recovery Device ${getWorkExchangerName()}`}</div>
              <div className='work-exchanger-grid-container no_drag'>
                <Tooltip title='Close'>
                  <img src={closeIconBlack} alt='close' onClick={handleCloseWorkExchangerModal} className='pointer' />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='work-exchanger-body-container sansW4SeLig'>
              <Grid item xs={12}>
                <div className='work-exchanger-iobuttons'>
                  <ToggleButtonGroup color='primary' value={activeform} exclusive onChange={(e) => { setActiveForm(e.target.value); }}>
                    <ToggleButton value="work_exc" className='sansW4SeLig tab no_drag M_Regular'>{translateObject('Work Exchanger')}</ToggleButton>
                    <ToggleButton value="pressure_exc" className='sansW4SeLig tab no_drag M_Regular'>{translateObject('Pressure Exchanger')}</ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div className='work-exchanger-input-form' style={{ 'display': (activeform === 'work_exc') ? 'block' : 'none' }}>
                  <div className='work-exchanger-input'>
                    <div className='input-params' style={{ 'height': '300px', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Input Parameters')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        <ul className='even'>
                          <li><span className='no_drag S_Regular'>{translateObject('Manual or Auto Efficiencies')}</span></li>
                          <li><span className='no_drag S_Regular' /></li>
                          <li className='highilted'>
                            <div className='no_drag'>
                              <Select className='stackmodel S_Regular' fullWidth style={{ fontSize: 12 }} value={workExcModel} onChange={(e) => { getDefaultWorkExcData(e, 'work_exc'); }}>
                                {stackModels.map((names, ind) => {
                                  return (
                                    <MenuItem key={ind} value={names} onClick={setWorkExcModel}>
                                      {names}
                                    </MenuItem>);
                                })}
                              </Select>
                            </div>
                          </li>
                        </ul>
                        {workExchangerVal.length > 0 && workExchangerVal.map((ele, ind) => {
                          if (ele.name === 'input') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'odd' : 'even'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    <input onMouseDown={(e) => getCurrentValue(e)}
                                      onFocus={e => e.target.select()} onBlur={(e) => { blurVal('work', ind, e); }} onChange={(e) => { changeVal('work', ind, e); }} type='number' disabled={!ele.class} value={ele.val} />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                    <div className='input-params' style={{ 'height': '300px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Work Exchanger Performance')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {workExchangerVal.length > 0 && workExchangerVal.map((ele, ind) => {
                          if (ele.name === 'performance') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li>
                                  <span className='no_drag S_Regular'>
                                    <input type='text' value={ele.val} disabled />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                  </div>
                  <div className='work-exchanger-input' style={{ marginTop: '15px' }}>
                    <div className='input-params' style={{ height: 'auto', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Work Exchanger Power results')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      {workExchangerVal.length > 0 && workExchangerVal.map((ele, ind) => {
                        if (ele.name === 'power') {
                          return (
                            <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                              <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                              <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                              <li>
                                <span className='no_drag S_Regular'>
                                  <input type='text' value={ele.val} disabled />
                                </span>
                              </li>
                            </ul>
                          );
                        }
                        return '';
                      })}
                    </div>
                    <div className='input-params' style={{ height: 'auto' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Circulation/Booster Pump')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      {workExchangerVal.length > 0 && workExchangerVal.map((ele, ind) => {
                        if (ele.name === 'circulation') {
                          return (
                            <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                              <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                              <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                              <li>
                                <span className='no_drag S_Regular'>
                                  <input type='text' value={ele.val} disabled />
                                </span>
                              </li>
                            </ul>
                          );
                        }
                        return '';
                      })}
                    </div>
                  </div>
                </div>
                <div className='pressure-exchanger-input-form' style={{ 'display': (activeform === 'pressure_exc') ? 'block' : 'none' }}>
                  <div className='work-exchanger-input'>
                    <div className='input-params' style={{ height: '300px', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Input Parameters')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        <ul className='even'>
                          <li><span className='no_drag S_Regular'>{translateObject('Manual or Auto Efficiencies')}</span></li>
                          <li><span className='no_drag S_Regular' /></li>
                          <li className='highilted'>
                            <div className='no_drag'>
                              <Select className='stackmodel' fullWidth style={{ fontSize: 12 }} value={pressExcModel} onChange={(e) => { getDefaultWorkExcData(e, 'pressure_exc'); }}>
                                {stackModels.map((names, ind) => {
                                  return (
                                    <MenuItem key={ind} value={names} onClick={setPressExcModel}>
                                      {names}
                                    </MenuItem>);
                                })}
                              </Select>
                            </div>
                          </li>
                        </ul>
                        {pressureExchangerVal.length > 0 && pressureExchangerVal.map((ele, ind) => {
                          if (ele.name === 'input') {
                            return (
                              <ul key={ind} className={(ind % 2 === 1) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    <input onBlur={(e) => { blurVal('press', ind, e); }}
                                      onFocus={e => e.target.select()} onChange={(e) => { changeVal('press', ind, e); }} type='number' disabled={!ele.class} value={ele.val} />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                    <div className='input-params' style={{ height: '300px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Pressure Exchanger Performance')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {pressureExchangerVal.length > 0 && pressureExchangerVal.map((ele, ind) => {
                          if (ele.name === 'performance') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li>
                                  <span className='no_drag S_Regular'>
                                    <input type='text' value={ele.val} disabled />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                  </div>
                  <div className='work-exchanger-input' style={{ marginTop: '15px' }}>
                    <div className='input-params' style={{ height: 'auto', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Pressure Exchanger Power results')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      {pressureExchangerVal.length > 0 && pressureExchangerVal.map((ele, ind) => {
                        if (ele.name === 'power') {
                          return (
                            <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                              <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                              <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                              <li>
                                <span className='no_drag S_Regular'>
                                  <input type='text' value={ele.val} disabled />
                                </span>
                              </li>
                            </ul>
                          );
                        }
                        return '';
                      })}
                    </div>
                    <div className='input-params' style={{ height: 'auto' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Circulation/Booster Pump')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      {pressureExchangerVal.length > 0 && pressureExchangerVal.map((ele, ind) => {
                        if (ele.name === 'circulation') {
                          return (
                            <ul key={ind} className={(ind % 2 === 1) ? 'even' : 'odd'}>
                              <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                              <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                              <li>
                                <span className='no_drag S_Regular'>
                                  <input type='text' value={ele.val} disabled />
                                </span>
                              </li>
                            </ul>
                          );
                        }
                        return '';
                      })}
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='edi-button'>
                  <Stack spacing={2} direction='row'>
                    <Button variant='contained' size='small' className='sansW4SeLig ok no_drag M_Bold Primary_Default_Button' onClick={() => setDataOnStorage()}> {translateObject('OK')}</Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default WorkExchangerForm;